import { DateTime } from 'ui/components/DateTime'
import { Link } from 'ui/components/Link'
import { TableColumn } from 'ui/components/Table'
import { BankUsersReportItem } from '~bank-reports/types/BankUsersReport'

import { CheckMark } from '../../../../components/CheckMark'

export const columns = (availableSortFields: string[]): TableColumn<BankUsersReportItem>[] => [
  {
    title: 'First Name',
    key: 'firstName',
    align: 'left',
    sortable: availableSortFields.includes('firstName')
  },
  {
    title: 'Last Name',
    key: 'lastName',
    align: 'left',
    sortable: availableSortFields.includes('lastName')
  },
  {
    title: 'Active',
    align: 'left',
    sortable: availableSortFields.includes('active'),
    key: 'active',
    render: ({ active }) => <CheckMark active={active} />
  },
  {
    title: 'Email',
    align: 'left',
    sortable: availableSortFields.includes('email'),
    key: 'email',
    render: ({ email }) => <Link to={`mailto:${email}` as never}>{email}</Link>
  },
  {
    title: 'Phone',
    key: 'phone',
    align: 'left',
    sortable: availableSortFields.includes('phone')
  },
  {
    title: 'Role',
    key: 'role',
    align: 'left',
    sortable: availableSortFields.includes('role')
  },
  {
    title: 'Created',
    align: 'left',
    sortable: availableSortFields.includes('createdAt'),
    key: 'createdAt',
    render: ({ createdAt }) => <DateTime date={createdAt} />
  },
  {
    title: 'Last login',
    align: 'left',
    sortable: availableSortFields.includes('lastLoginAt'),
    key: 'lastLoginAt',
    render: ({ lastLoginAt }) => <DateTime date={lastLoginAt} />
  }
]
